export default __webpack_public_path__ + "static/media/assign.e9f0d306.svg";